module.exports = __webpack_public_path__ + "static/img/1.a7127ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/zh/1.png
// module id = zNdB
// module chunks = 0